import { Flex, useColorModeValue } from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';
import { MultiValue } from 'chakra-react-select';

import { AvatarOptionIcon, AvatarOptionProps } from './avatar-option';

export const AvatarTooltip = ({ values }: { values: MultiValue<AvatarOptionProps> }) => {
  const textColor = useColorModeValue('gray.300', 'gray.700');

  if (!values || values.length === 0) return null;

  return (
    <Flex gap={3} flexWrap="wrap">
      {values.map((value) => (
        <Flex key={value.id} gap={2} alignItems="center">
          <AvatarOptionIcon
            size="xs"
            displayName={value.displayName}
            avatarUrl={value.avatarUrl}
            kind={value.kind}
          />
          <Text size="xs" weight="medium" color="inherit">
            {value.displayName}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
